import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import profile from '../assets/images/profile.jpeg';
// Import your tool logos (adjust filenames as necessary)
import awsLogo from '../assets/images/aws-logo.png';
import terraformLogo from '../assets/images/terraform-logo.png';
import gcpLogo from '../assets/images/gcp-logo.png';
import dockerLogo from '../assets/images/docker-logo.webp';
import kubernetesLogo from '../assets/images/kubernetes-logo.png';
import reactLogo from '../assets/images/react-logo.png';
import nodejsLogo from '../assets/images/nodejs-logo.png';
import pythonLogo from '../assets/images/python-logo.png';
import gitLogo from '../assets/images/git-logo.png';
import jenkinsLogo from '../assets/images/jenkins-logo.png';
import firebaseLogo from '../assets/images/firebase-logo.png';
import githubLogo from '../assets/images/github-logo.png';
import angularLogo from '../assets/images/angular-logo.png';
import dotnetLogo from '../assets/images/dotnet-logo.png';
import linuxLogo from '../assets/images/linux-logo.png';
import lambdaLogo from '../assets/images/lambda-logo.png';
import gatewayLogo from '../assets/images/gateway-logo.png';
import postgresqlLogo from '../assets/images/postgresql-logo.png';

function Main() {
  // Array of tools with their logos
  const tools = [
    { name: "AWS", logo: awsLogo },
    { name: "Terraform", logo: terraformLogo },
    { name: "GCP", logo: gcpLogo },
    { name: "Docker", logo: dockerLogo },
    { name: "Kubernetes", logo: kubernetesLogo },
    { name: "React", logo: reactLogo },
    { name: "Node.js", logo: nodejsLogo },
    { name: "Python", logo: pythonLogo },
    { name: "Git", logo: gitLogo },
    { name: "Jenkins", logo: jenkinsLogo },
    { name: "Firebase", logo: firebaseLogo },
    { name: "Github", logo: githubLogo },
    { name: "Angular", logo: angularLogo },
    { name: "Dotnet", logo: dotnetLogo },
    { name: "Linux", logo: linuxLogo },
    { name: "Lambda", logo: lambdaLogo },
    { name: "Gateway", logo: gatewayLogo },
    { name: "Postgresql", logo: postgresqlLogo },
  ];

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={profile} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/rohan0912" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/rohan-nair-558b7b1b6/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
          </div>
          <h1>Rohan Nair</h1>
          <p>Software Engineer</p>
          <div className="mobile_social_icons">
            <a href="https://github.com/rohan0912" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/rohan-nair-558b7b1b6/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
          </div>
        </div>
      </div>
      {/* Marquee with logos */}
      <div className="footer-marquee">
        <div className="marquee-content">
          {tools.map((tool, index) => (
            <img key={index} src={tool.logo} alt={`${tool.name} logo`} />
          ))}
          {tools.map((tool, index) => (
            <img key={index + tools.length} src={tool.logo} alt={`${tool.name} logo`} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Main;